module.exports = __webpack_public_path__ + "static/datamanEn-9b34e7235a78e339d02d39e802165137.png";